import { getQueryClient } from '@/api/queryClient';
import { graphql, type ResultOf, type VariablesOf } from '@/graphql';
import logToDatadog from '@/logger/logToDatadog';
import gqlClient from '@/utils/gqlClient';

import {
  getCartIdCookie,
  invalidateCartData,
  saveCartIdCookie,
} from '../utils/cartUtils';

export const mutation = graphql(`
  mutation RemoveFromCart(
    $cartId: String
    $skuCode: String!
    $parentId: String
  ) {
    cartRemoveLineItem(
      cartId: $cartId
      skuCode: $skuCode
      parentId: $parentId
    ) {
      cartId
      resultCategory
      errorCode
      invalidReason
    }
  }
`);

export type RemoveFromCartResult = ResultOf<typeof mutation>;
export type RemoveFromCartVariables = VariablesOf<typeof mutation>;

export function withQueryKey(vars: RemoveFromCartVariables) {
  return {
    queryKey: ['removeFromCart', vars.cartId, vars.skuCode, vars.parentId],
    queryFn: async () => {
      try {
        const data = await gqlClient().request(mutation, vars);
        const removeResult = data.cartRemoveLineItem;

        if (
          removeResult.cartId &&
          (!removeResult.invalidReason || !removeResult.errorCode)
        ) {
          saveCartIdCookie(removeResult.cartId);
        }

        invalidateCartData();

        return data;
      } catch (error) {
        logToDatadog({
          error,
          message: 'RemoveFromCart query failed',
          module: 'cart',
        });
        return null;
      }
    },
  };
}

export async function removeFromCart(skuCode: string, parentId: string | null) {
  const cartId = getCartIdCookie();
  const queryClient = getQueryClient();

  return queryClient.fetchQuery({
    ...withQueryKey({ cartId, skuCode, parentId }),
  });
}
